import Constants from '../../../utils/Constants';
import Slider from 'react-slick';
import { finishedProjects } from './finishedProjects';

const Finished = () => {
  const slickSettingsImgs = {
    className: 'center',
    focusOnSelect: true,
    infinite: true,
    centerMode: true,
    centerPadding: '400px',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1921,
        settings: {
          centerPadding: '300px',
        },
      },
      {
        breakpoint: 1441,
        settings: {
          centerPadding: '200px',
        },
      },
      {
        breakpoint: 1025,
        settings: {
          centerPadding: '100px',
        },
      },
      {
        breakpoint: 881,
        settings: {
          centerPadding: '0px',
          centerMode: false,
        },
      },
    ],
  };

  return (
    <div id={Constants.FINISHED} className='finished'>
      <div className='finished_container container_wide'>
        <h2
          data-aos='fade-up'
          className='text_center container'
        >
          ZAVRŠENI PROJEKTI
        </h2>
        <p data-aos='fade-up' data-aos-delay='50' className='mb_2 container'>
          Zajedno sa sestrinskim firmama Manas d.o.o. i Radović Gradnja d.o.o.
          realizirali smo više stambeno-poslovnih projekata na području Splita i
          Solina
        </p>
        <Slider {...slickSettingsImgs}>
          {finishedProjects.map((project) => (
            <div className='finished_container_slider_container pointer'>
              <div
                data-aos='fade-up'
                className='finished_container_slider_container_card'
              >
                <img
                  data-aos='fade-up'
                  data-aos-delay='50'
                  src={project.imgPath}
                  alt={project.title}
                />
                <div
                  data-aos='fade-up'
                  data-aos-delay='100'
                  className='finished_container_slider_container_card_text'
                >
                  <h2>{project.title}</h2>
                  <p>{project.apartments}</p>
                  <p>{project.parking}</p>
                  <p>{project.additional}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
export default Finished;
